var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LanguageService } from './language.service';
import { TranslateService } from '@ngx-translate/core';
var BrowserLanguageService = /** @class */ (function (_super) {
    __extends(BrowserLanguageService, _super);
    function BrowserLanguageService(translationService) {
        var _this = _super.call(this) || this;
        _this.translationService = translationService;
        return _this;
    }
    BrowserLanguageService.prototype.setCurrentLanguage = function (locale) {
        var lang = locale || (navigator && navigator.languages && navigator.languages[0]);
        if (!lang) {
            return;
        }
        for (var _i = 0, _a = this.translationService.getLangs(); _i < _a.length; _i++) {
            var language = _a[_i];
            if (language.startsWith(lang.split('_')[0])) {
                this.translationService.setDefaultLang(language);
                break;
            }
        }
    };
    return BrowserLanguageService;
}(LanguageService));
export { BrowserLanguageService };
